import {
  MDBCol,
  MDBRow,
  MDBContainer,
  MDBIcon,
} from 'mdb-react-ui-kit';

function Contact() {
  return (
    <div style={{
      backgroundColor: '#0e1530',
      paddingTop: '16px',
      paddingBottom: '16px',
      borderTop: '1px solid rgba(74, 158, 71, 0.3)',
    }}>
      <h2 style={{
        textAlign: 'center',
        color: '#fff',
        fontFamily: 'Consolas, monospace',
        fontSize: '20px',
        letterSpacing: '3px',
        marginBottom: '8px',
      }}>
        CONTACT
      </h2>
      <div style={{
        width: '90%', height: '2px',
        backgroundColor: '#4A9E47',
        margin: '0 auto 14px',
      }} />

      <MDBContainer fluid>
        <MDBRow className="align-items-center">

          <MDBCol lg="3" md="6" sm="12" className="d-flex align-items-center justify-content-center" style={{ marginBottom: '8px' }}>
            <MDBIcon fas icon="fa-solid fa-envelope" size="lg" className="me-2" style={{ color: '#4A9E47' }} />
            <span style={{ color: 'rgba(255,255,255,0.8)', fontFamily: 'Consolas, monospace', fontSize: '14px' }}>
              sh.courseaularge@gmail.com
            </span>
          </MDBCol>

          <MDBCol lg="3" md="6" sm="12" className="d-flex align-items-center justify-content-center" style={{ marginBottom: '8px' }}>
            <a href="https://www.facebook.com/profile.php?id=61566151288118"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center"
              style={{ textDecoration: 'none' }}>
              <MDBIcon fab icon="facebook" size="lg" className="me-2" style={{ color: '#4A9E47' }} />
              <span style={{ color: 'rgba(255,255,255,0.8)', fontFamily: 'Consolas, monospace', fontSize: '14px' }}>
                SH course au large - mini 650
              </span>
            </a>
          </MDBCol>

          <MDBCol lg="3" md="6" sm="12" className="d-flex align-items-center justify-content-center" style={{ marginBottom: '8px' }}>
            <a href="https://www.instagram.com/sh_course_au_large_mini650/"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center"
              style={{ textDecoration: 'none' }}>
              <MDBIcon fab icon="instagram" size="lg" className="me-2" style={{ color: '#4A9E47' }} />
              <span style={{ color: 'rgba(255,255,255,0.8)', fontFamily: 'Consolas, monospace', fontSize: '14px' }}>
                sh_course_au_large_mini650
              </span>
            </a>
          </MDBCol>

          <MDBCol lg="3" md="6" sm="12" className="d-flex align-items-center justify-content-center" style={{ marginBottom: '8px' }}>
            <MDBIcon fas icon="fa-solid fa-phone" size="lg" className="me-2" style={{ color: '#4A9E47' }} />
            <span style={{ color: 'rgba(255,255,255,0.8)', fontFamily: 'Consolas, monospace', fontSize: '14px' }}>
              06 52 61 06 79 / 06 95 61 21 04
            </span>
          </MDBCol>

        </MDBRow>
      </MDBContainer>
    </div>
  );
}

export default Contact;
